import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useUserStore from '../../store/UserStore';
import useAuth from '../../utilities/useAuth';
import { useIsViewing } from '../../utilities/customHooks/useIsViewing';
import { analytics } from '../../modules/analytics';
import { useUnifiedDashboardStore } from '../../store/UnifiedDashboardStore';

import { isVatikaUser } from './header.rules';

export interface HeaderActions {
  isStaff: boolean;
  isViewing: boolean;
  showVatikaLogo: boolean;
}

export const useHeaderActions = (): HeaderActions => {
  const { isStaff, email } = useAuth();
  const { userId, userName } = useUserStore();
  const isViewing = useIsViewing();

  useEffect(() => {
    if (userId) {
      analytics.identifyUser({ distinctId: userId, userProperties: { email, name: userName } });
    }
  }, []);

  return { isStaff, isViewing, showVatikaLogo: isVatikaUser(email) };
};

export const useGoToLanding = (): (() => void) => {
  const navigate = useNavigate();
  const { landingPage } = useUserStore();

  return () => {
    const isOperatorCheckedIn = localStorage.getItem('OperatorCheckedIn');
    useUnifiedDashboardStore.getState().resetUnifiedDashboardStore();
    navigate(isOperatorCheckedIn ? '/task-list' : landingPage || '/');
  };
};
